<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <caja-mensual-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import CajaMensualCrud from "./CajaMensualCrud";
    export default {
        name: "CajaMensual",
        components: {CajaMensualCrud}
    }
</script>

<style scoped>

</style>

